/**
 * Zweck: Beschreibt class GuiMessage und ihren Daten- oder Funktionsvertrag.
 */
/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/gui-message.ts.
 */
export class GuiMessage {
  state: string;
  message: string;
}
